(() => {
  'use strict';

  const isInternalReferrer = () => {
    try {
      if (!document.referrer) return false;
      return new URL(document.referrer).origin === window.location.origin;
    } catch (error) {
      return false;
    }
  };

  const bindBackButton = (button) => {
    if (button.dataset.tmBackReady === 'true') return;

    button.dataset.tmBackReady = 'true';
    button.addEventListener('click', () => {
      const fallback = button.dataset.fallbackUrl || '/collections/all';

      if (isInternalReferrer() && window.history.length > 1) {
        window.history.back();
        return;
      }

      window.location.href = fallback;
    });
  };

  const bindBackButtons = () => {
    document.querySelectorAll('[data-tm-back]').forEach(bindBackButton);
  };

  const ensurePolicyBackButton = () => {
    if (!window.location.pathname.includes('/policies/')) return;

    const container = document.querySelector('.shopify-policy__container');
    if (!container || document.querySelector('.tm-back-wrap--policy')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'tm-back-wrap tm-back-wrap--policy';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tm-back-button';
    button.dataset.tmBack = '';
    button.dataset.fallbackUrl = '/';
    button.innerHTML = '<span class="tm-back-button__icon" aria-hidden="true">&larr;</span><span>Volver</span>';

    wrapper.appendChild(button);
    container.insertAdjacentElement('beforebegin', wrapper);
  };

  ensurePolicyBackButton();
  bindBackButtons();
})();
